// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-template{min-height:calc(var(--vh, 1vh)*100)!important;display:flex}@media screen and (min-height:800px){.message-template{max-height:calc(var(--vh, 1vh)*100)!important;align-items:center!important}}", ""]);
// Exports
module.exports = exports;
